import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalAtomModule } from 'src/app/components/atoms/modal/modal.module';
import { ButtonAtomModule } from 'src/app/components/atoms/button/button.module';
import { SessionExpiredComponent } from './session-expired.component';



@NgModule({
  declarations: [SessionExpiredComponent],
  imports: [
    CommonModule,
    ModalAtomModule,
    ButtonAtomModule
  ],
  exports: [SessionExpiredComponent]
})
export class SessionExpiredModule { }
